module.exports = __webpack_public_path__ + "static/media/xb.36348eb0.jpg";